import { mainApi } from "services/main/api";

export type AgentActionReviewStatus = "PENDING" | "PROCESSING" | "COMPLETED";

export type AgentActionStatus =
  | "PENDING"
  | "APPROVED"
  | "DENIED"
  | "PROCESSING"
  | "EXECUTED"
  | "FAILED";

export type AgentActionResourceType = "TASK";

export type AgentActionOperationType = "CREATE" | "UPDATE";

export type AgentActionDecision = "APPROVED" | "DENIED";

export interface AgentActionDiff {
  fieldName: string;
  before?: string;
  after?: string;
}

export interface AgentActionDetail {
  actionId: string;
  resourceType: AgentActionResourceType;
  operationType: AgentActionOperationType;
  resourceId?: string;
  resourceName?: string;
  resourceShortId?: string;
  status: AgentActionStatus;
  payload?: string;
  diffs?: AgentActionDiff[];
  errorMessage?: string;
}

export interface GetAgentActionReviewResponse {
  reviewId: string;
  teamName: string;
  status: AgentActionReviewStatus;
  createdBy: string;
  createdAt: number;
  actions: AgentActionDetail[];
}

export interface AgentActionDecisionInput {
  actionId: string;
  decision: AgentActionDecision;
}

export interface CompleteAgentActionReviewRequest {
  reviewId: string;
  decisions: AgentActionDecisionInput[];
}

export interface CompleteAgentActionReviewResponse {
  reviewId: string;
  status: AgentActionReviewStatus;
}

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgentActionReview: builder.query<
      GetAgentActionReviewResponse,
      { reviewId: string }
    >({
      query: ({ reviewId }) => ({
        url: `agent-action-reviews/${reviewId}`,
      }),
      providesTags: (_result, _error, { reviewId }) => [
        { type: "AgentActionReviews", id: reviewId },
      ],
    }),
    completeAgentActionReview: builder.mutation<
      CompleteAgentActionReviewResponse,
      CompleteAgentActionReviewRequest
    >({
      query: ({ reviewId, ...body }) => ({
        url: `agent-action-reviews/${reviewId}/complete`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { reviewId }) => [
        { type: "AgentActionReviews", id: reviewId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAgentActionReviewQuery,
  useLazyGetAgentActionReviewQuery,
  useCompleteAgentActionReviewMutation,
} = extendedApi;
